import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EndorsementHistoryComponent } from './endorsement-history/endorsement-history.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { HeaderModule } from '../header/header.module';
import { HomeModule } from '../home/home.module';
import { RouterModule } from '@angular/router';
import { RequestEndorsementComponent } from './request-endorsement/request-endorsement.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { EndorsementBasicInfoComponent } from './endorsement-basic-info/endorsement-basic-info.component';
import { EndorsementUnderwritingFormComponent } from './endorsement-underwriting-form/endorsement-underwriting-form.component';
import { EndorsementReviewComponent } from './endorsement-review/endorsement-review.component';



@NgModule({
  declarations: [EndorsementHistoryComponent, RequestEndorsementComponent, EndorsementBasicInfoComponent, EndorsementUnderwritingFormComponent, EndorsementReviewComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    HeaderModule,
    HomeModule,
    RouterModule
  ]
})
export class EndorsementModule { }
